import { render, staticRenderFns } from "./ProjectDestinies.vue?vue&type=template&id=aa74f590&scoped=true&"
import script from "./ProjectDestinies.vue?vue&type=script&lang=js&"
export * from "./ProjectDestinies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa74f590",
  null
  
)

export default component.exports